import { render, staticRenderFns } from "./PagamentoStore.vue?vue&type=template&id=32f4105d&"
import script from "./PagamentoStore.vue?vue&type=script&lang=js&"
export * from "./PagamentoStore.vue?vue&type=script&lang=js&"
import style0 from "./PagamentoStore.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports